import React, { useState, useCallback, useEffect } from 'react';
import PopupGraph from '../../../../components/Popup/PopupGraph/PopupGraph';
import { getUniqueId } from '../../../../utilities/helpers/common';
import { TLatexExpression } from '../../../../typings/common';
import { textContentSelector } from '../../../../utilities/constants/common';
import { dataLayerGA } from '../../../../services/analytics/dataLayerGa';

interface Props {
  children: React.ReactNode;
}

const getLatexFromKatex = (el: Element): string | null => {
  const annotation = el.querySelector(
    'annotation[encoding="application/x-tex"]'
  );
  return annotation?.textContent?.trim() || null;
};

const EditorLayoutWrapper: React.FC<Props> = (props) => {
  const { children } = props;

  const [latexExpressions, setLatexExpressions] = useState<TLatexExpression[]>(
    []
  );
  const [isOpenGraphPopup, setIsOpenGraphPopup] = useState(false);

  const handleLatexClick = useCallback((latex: string) => {
    setLatexExpressions((prev) => {
      if (prev.some((x) => x.latex === latex)) return prev;
      return [...prev, { id: getUniqueId(), latex }];
    });

    setIsOpenGraphPopup(true);
    dataLayerGA.openGraphPopup();
  }, []);

  const handleCloseGraph = useCallback(() => {
    setIsOpenGraphPopup(false);
  }, []);

  useEffect(() => {
    const handleClick = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (!target) return;

      const katexEl = target.closest('.katex');
      if (!katexEl) return;

      const latex = getLatexFromKatex(katexEl);
      if (!latex) return;

      handleLatexClick(latex);
      dataLayerGA.clickKatexExpression();
    };

    const textContentEl = document.querySelector(`.${textContentSelector}`);
    if (!textContentEl) return;

    textContentEl.addEventListener('click', handleClick);
    // eslint-disable-next-line consistent-return
    return () => textContentEl.removeEventListener('click', handleClick);
  }, [handleLatexClick]);

  return (
    <>
      {isOpenGraphPopup && (
        <PopupGraph
          isOpen={isOpenGraphPopup}
          onClose={handleCloseGraph}
          latexExpressions={latexExpressions}
          setLatexExpressions={setLatexExpressions}
        />
      )}

      {children}
    </>
  );
};

export default EditorLayoutWrapper;
